import React, { useContext } from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { useNavigate } from 'react-router-dom';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const TermsUseAncillaryPage = (): JSX.Element => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayName, brandVanityUrl, brandAddress } = brand;

  const goBack = (): void => {
    navigate(-1);
  };

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>Website Terms Of Use</h2>
      <p>
        The site is owned by Car Care Plan Limited, which is registered in
        England, Company No. 850195 at Jubilee House, 5 Midpoint Business Park,
        Thornbury, West Yorkshire, BD3 7AG. Car Care Plan Limited is referred to
        as “we” or “us”.
      </p>
      <h4>Regulatory information and terms and conditions of use</h4>
      <p>
        The following contains conditions of use governing your use of the
        website pages at {brandVanityUrl} (the "Site"). By using this Site you
        hereby agree to these conditions of use in force at that time.
      </p>
      <p>
        If you wish to contact us regarding any matter set out in these
        conditions you may do so by contacting us by phone, or by writing to us.
      </p>
      <p>
        Whilst we have taken care in the preparation of the Site, certain
        technical matters may be beyond our control and we cannot guarantee that
        you will have uninterrupted or error free access to all of the Site at
        all times, that defects will be remedied, or that the Site, or the
        server that makes the Site available, are virus or bug free. Access may
        be suspended occasionally or restricted to allow for repair or
        maintenance or for the introduction of new services or other reasons.
      </p>
      <h4>Use of personal information</h4>
      <p>
        Through your use of the Site you agree that personal information that is
        provided will be dealt with in accordance with our Fair Use Notice.
      </p>
      <h4>Trademarks</h4>
      <p>
        Images, logos, names and trademarks on the Site are proprietary marks of
        Car Care Plan Limited and/or {brandAddress} or any applicable relevant
        third party. Unless otherwise agreed in writing nothing on the Site
        shall be deemed to confer on any person any licence or right to use any
        such image, logo, name or trademark and any such use may constitute an
        infringement of the rights of the holder.
      </p>
      <h4>Ownership of all materials on the site</h4>
      <p>
        We are the owner of all copyright, design, graphical and text
        arrangements, database rights and other intellectual property rights
        that exist in the content of the Site unless otherwise stated. The Site
        is intended for non-commercial personal use only. You may not
        commercially exploit, publish, distribute, extract, re-utilise or
        reproduce any part of the Site in any material form (including
        photocopying or storing it in any medium by electronic means) or use it
        in any other way other than in accordance with the limited use licence
        set out in our copyright notice.
      </p>
      <p>
        Interference or entry to the Site with intent to corrupt, damage or deny
        service from the Site or for other commercial benefit shall be taken
        seriously and we shall take such action as is necessary to protect the
        Site from any such activities to protect our intellectual property
        rights. You acknowledge that damages may not be an adequate remedy for
        any infringement of such rights by you and that we are entitled to the
        remedies of injunction, specific performance, orders to deliver up
        infringing copies and any other statutory or equitable relief for any
        threatened or actual infringement and that no proof of special damages
        is necessary for reliance on such remedies.
      </p>
      <h4>Product terms and conditions</h4>
      <p>
        The content of the Site does not constitute an offer by us to sell
        products and services. Your request to purchase a product or service
        represents an offer by you and will be subject to the terms and
        conditions of that product or service that we may accept or reject.
        After you make a request through the Site to purchase the product or
        service then assuming such product or service is available to you and
        your offer is accepted, you will receive confirmation of your purchase.
      </p>
      <p>
        The information and descriptions on the Site do not necessarily
        represent complete descriptions of all terms, conditions and exclusions
        and the precise cover provided (as applicable) shall be included in the
        schedule of cover, policy documents and/or conditions of purchase issued
        to you. If you apply for any product or service detailed on the Site,
        these conditions of use should be read in conjunction with any other
        terms and conditions relating to that product or service and, in the
        event of any contradiction between these conditions of use and the
        specific product of service terms and conditions, the latter shall
        prevail.
      </p>
      <p>
        You must ensure that the details you give to us while using this Site
        are correct and that there are sufficient funds to cover the cost of the
        product or service.
      </p>
      <h4>External links</h4>
      <p>
        We may provide links to other websites that are not under our control.
        These links are provided for your convenience. When you activate these
        links, you will leave the Site. We do not endorse or take responsibility
        for the content on third party websites or the availability of those
        websites and we are not liable for any loss or damage that you may
        suffer by using those websites. If you decide to access linked websites
        you do so at your own risk.
      </p>
      <h4>Site access and password usage</h4>
      <p>
        The Site is directed at those who can access the Site from the UK and is
        intended for use by UK residents only. Applications for products from
        non-UK residents will, unless otherwise stated, not be accepted.
      </p>
      <p>
        {brandDisplayName} Dealers who obtain access for the purpose of 7 Day
        insurance and Excess Protect, with a username and password are
        responsible for maintaining the confidentiality of your details and your
        password and for restricting access to your computer to prevent
        unauthorised access to your Dealer account. You accept responsibility
        for activities that occur under your account and you should take all
        steps to ensure your password is kept confidential. You agree to inform
        us immediately if you have reason to believe your password is being used
        in an unauthorised manner.
      </p>
      <p>
        You must not use the Site in any way that causes or is likely to cause
        access to be interrupted, or impaired in any way and you acknowledge and
        agree that you are responsible for electronic communications sent from
        your computer.
      </p>
      <h4>Disclaimer</h4>
      <p>
        We will do our best to correct errors and omissions as soon as we can.
        Nevertheless on occasion there may be mistakes in the price or type of
        product shown. In the event that such error in price, product or service
        is shown then we reserve the right to cancel that contract, but this of
        course will be without any liability to you and a refund will be
        offered.
      </p>
      <p>
        The following provisions should be read carefully as they exclude or
        limit our legal liability in connection with your use of this website.
        Nothing in these terms and conditions attempts to exclude liability that
        is not permissible under applicable law, including without limitation,
        death or personal injury, or for fraudulent misrepresentation.
      </p>
      <p>
        Nothing in these terms and conditions shall exclude, limit or restrict
        our duties and liabilities to you under the Financial Services and
        Markets Act 2000, or any conduct of business rules that we are bound to
        comply with.
      </p>
      <p>
        While we have taken all reasonable steps to ensure the accuracy and
        completeness of the content of the website, we exclude any warranties,
        undertakings or representations (either express or implied) to the full
        extent permitted under applicable law, that the website or (including
        without limitation) all or any part of the content or materials,
        accuracy, availability or completeness of the content of the website or
        any part of the content or materials are appropriate or available for
        use either in the United Kingdom or in other jurisdictions. If you use
        this website from other jurisdictions, you are responsible for
        compliance with applicable local laws.
      </p>
      <p>
        We accept no liability in contract, tort, negligence, statutory duty or
        otherwise (to the maximum extent permitted by applicable law) arising
        out of the use of or access to this website (which includes without
        limitation) any errors or omissions contained in this website or if the
        website is unavailable and we shall not be liable for any direct or
        indirect:
      </p>
      <ol>
        <li>
          economic losses (including without limitation loss of revenues, data,
          profits, contracts, use, opportunity, business or anticipated
          savings);
        </li>
        <li>loss of goodwill or reputation;</li>
        <li>
          special, incidental, consequential loss or damage, suffered or
          incurred arising out of or in connection with your use of this website
          and these terms and conditions.
        </li>
      </ol>
      <p>
        Access to and use of this website is at the user's own risk and we do
        not warrant that the use of this website or any material downloaded from
        it will not cause damage to any property, or otherwise minimise or
        eliminate the inherent risks of the internet including but not limited
        to loss of data, computer virus infection, spyware, malicious software,
        trojans and worms. Also, we accept no liability in respect of losses or
        damages arising out of changes made to the content of this website by
        unauthorised third parties.
      </p>
      <p>
        Please note that this disclaimer does not affect your statutory rights
        in respect of any products or services that you purchase from this site.
      </p>
      <h4>Amendment to these conditions of use</h4>
      <p>
        We reserve the right to amend the Site and these conditions of use
        without notice from time to time. Any such amendment shall be effective
        once the revisions have been posted on this Site. As these Conditions of
        Use may be updated from time to time, we suggest that you check them
        whenever you visit the Site.
      </p>
      <p>
        If any of these provisions shall be unlawful, void or unenforceable for
        any reason the particular provision shall be deemed deleted and will not
        affect the validity or enforceability of the remaining provisions.
      </p>
      <h4>Monitoring of telephone calls and emails</h4>
      <p>
        Telephone calls and email correspondence with us as a result of your
        access to the Site may be recorded for training purposes and to assist
        in the prevention of fraud. By using such communication methods you are
        consenting to such activities taking place.
      </p>
      <h4>Waiver</h4>
      <p>
        If you breach these terms of use and we do not take immediate action
        against you we are still entitled to enforce our rights and remedies in
        respect of any such breach or any subsequent breach.
      </p>
      <h4>Jurisdiction and Law</h4>
      <p>
        These conditions of use shall be governed by and construed in accordance
        with English law. Disputes arising here from shall be subject to the
        exclusive jurisdiction of the courts of English courts.
      </p>
      <h4>Copyright</h4>
      <p>
        ©2023 Car Care Plan Limited. All rights, save as expressly granted, are
        reserved. Reproduction in any form of any part of the contents of this
        Site without our prior written consent is prohibited unless for personal
        use only.
      </p>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default TermsUseAncillaryPage;
